import { render, staticRenderFns } from "./AddGroup.vue?vue&type=template&id=30f7b1a4"
import script from "./AddGroup.vue?vue&type=script&lang=js"
export * from "./AddGroup.vue?vue&type=script&lang=js"
import style0 from "./AddGroup.vue?vue&type=style&index=0&id=30f7b1a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports